
/**
 * Определяет телефонные устройства
 */
export const isPhone = () => {
  return document.documentElement.classList.contains('mobile');
};
